import styled from 'styled-components';

export const StyledLegendWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;
`;

export const StyledLegendItemWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  align-items: center;
`;

export const StyledLegendIcon = styled.div<{ $color: string }>`
  height: 12px;
  width: 12px;
  background-color: ${({ $color }): string => $color};
  margin: ${({ theme }): string => theme.spacers!.spacer01};
`;

export const StyledLegendText = styled.div`
  font-family: InspireTWDC;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0;
  text-align: left;
  text-transform: capitalize;
`;
